import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Marquee from "@/components/Marquee";
import Showcase from "@/components/Showcase";
import ProductHighlights from "@/components/ProductHighlights";
import SizeChart from "@/components/SizeChart";
import FAQ from "@/components/FAQ";
import OrderForm from "@/components/OrderForm";
import StickyCTA from "@/components/StickyCTA";
import Footer from "@/components/Footer";
import { computeTotals } from "@/lib/shop";
import { scrollToId } from "@/lib/scroll";
import { captureUtm } from "@/lib/utm";

export default function LandingPage() {
    const [lines, setLines] = useState([]);
    const [zone, setZone] = useState("outside_dhaka");
    const [stock, setStock] = useState(null);
    const [formInView, setFormInView] = useState(false);
    const [kbOpen, setKbOpen] = useState(false);

    useEffect(() => {
        captureUtm();
    }, []);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/stock`)
            .then((r) => r.json())
            .then((d) => setStock(d.colors || null))
            .catch(() => {});
    }, []);

    useEffect(() => {
        const el = document.getElementById("order-form");
        if (!el) return;
        const ob = new IntersectionObserver(
            (entries) => setFormInView(entries[0].isIntersecting),
            { threshold: 0.05 },
        );
        ob.observe(el);
        return () => ob.disconnect();
    }, []);

    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return;
        const onResize = () => setKbOpen(window.innerHeight - vv.height > 150);
        vv.addEventListener("resize", onResize);
        return () => vv.removeEventListener("resize", onResize);
    }, []);

    const totals = computeTotals(lines, zone);

    return (
        <div className="min-h-screen bg-[#FBF9F5]">
            <Header />
            <main>
                            <Showcase />
                                                                                    <Marquee />
                                                        <ProductHighlights />
                                                                                                                <SizeChart />
                                                                                                                <OrderForm
                                                            lines={lines}
                                                            setLines={setLines}
                                                            zone={zone}
                                                            setZone={setZone}
                                                            stock={stock}
                                                        />
                                                        <FAQ />
                        </main>
            <Footer />
            <StickyCTA hidden={formInView || kbOpen} totals={totals} />
        </div>
    );
}
